"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAWSCDKConfig = void 0;
const config_1 = require("@root/config");
const resolvedEnvironmentVariables_1 = require("../resolvedEnvironmentVariables");
const { projectCode, stage } = resolvedEnvironmentVariables_1.resolvedEnvironmentVariables;
let defaultEnvironmentComputeDeploymentConfig = projectCode === 'i3012' || ['test', 'prod'].includes(stage) ? 'FARGATE' : 'LAMBDA';
if (projectCode === 'i3012' && stage === 'test') {
    defaultEnvironmentComputeDeploymentConfig = 'LAMBDA';
}
const defaultInterfaceEndpointDeployment = {
    dev: {
        timestream: false,
        cloudwatch: false,
        sns: false,
    },
    test: {
        timestream: false,
        cloudwatch: false,
        sns: false,
    },
    prod: {
        timestream: false,
        cloudwatch: false,
        sns: false,
    },
};
exports.defaultAWSCDKConfig /*& {ComputeDeploymentConfig: ComputeDeploymentConfig}*/ = {
    // ComputeDeploymentConfig: defaultComputDeploymentConfig,
    Cognito: {
        groupDefinitions: [],
        userInvitationConfig: {
            emailSubject: `${projectCode.substring(0, 4)}-${stage} User Registration`,
            emailBody: `{username}, you have been invited to register as a user of ${projectCode.substring(0, 4)} at app.${stage}.${projectCode.substring(0, 4)}.${config_1.parentHostedZoneName}
            Your password is {####}, this can be changed after logging in.`,
        },
    },
    Lamdba: {
        [`${projectCode}-${stage}-CalculatedState`]: {
            projectFunctionProps: {
                environment: {
                    DEFAULT_CANARY_ENV: 'DEFAULT',
                    CANARY_TEST_ENVARS: 'DEFAULT',
                },
            },
            /** used by cloudwatch alerts to configure settings for this lambda */
            alarmConfig: {
                metricInvocations: {
                    threshold: 1,
                    evaluationPeriods: 1,
                    alarmDescription: 'Alarm if Calculate state is involed less than once in 1 evaluation period',
                    comparisonOperator: 'LessThanThreshold',
                    treatMissingData: 'breaching',
                },
            },
        },
    },
    VPC: {
        interfaceEndpointDeployment: defaultInterfaceEndpointDeployment,
    },
    ECS: {
        Redis: {
            computeService: 'FARGATE',
            options: {
                scalingLimits: null,
                sizing: stage === 'prod'
                    ? { cpu: 512, memoryLimitMiB: 1024 }
                    : stage === 'test'
                        ? { cpu: 256, memoryLimitMiB: 512 }
                        : { cpu: 256, memoryLimitMiB: 512 },
            },
        },
        FanOut: defaultEnvironmentComputeDeploymentConfig === 'FARGATE'
            ? {
                computeService: 'FARGATE',
                options: {
                    scalingLimits: null,
                    sizing: stage === 'prod'
                        ? { cpu: 256, memoryLimitMiB: 512 }
                        : stage === 'test'
                            ? { cpu: 256, memoryLimitMiB: 512 }
                            : { cpu: 256, memoryLimitMiB: 512 },
                },
            }
            : { computeService: 'LAMBDA' },
        NetworkData: defaultEnvironmentComputeDeploymentConfig === 'FARGATE'
            ? {
                computeService: 'FARGATE',
                options: {
                    scalingLimits: {
                        minCapacity: stage === 'prod' ? 2 : 1,
                        maxCapacity: stage === 'prod' ? 5 : stage === 'test' ? 1 : 1,
                    },
                    capacityProviderStrategies: [
                        {
                            capacityProvider: 'FARGATE_SPOT',
                            weight: 1,
                        },
                        // {
                        //   capacityProvider: 'FARGATE',
                        //   weight: 0, // Optional: fallback to regular Fargate if desired
                        // }
                    ],
                    sizing: stage === 'prod'
                        ? { cpu: 256, memoryLimitMiB: 512 }
                        : stage === 'test'
                            ? { cpu: 256, memoryLimitMiB: 512 } // test ok
                            : { cpu: 256, memoryLimitMiB: 512 },
                },
            }
            : { computeService: 'LAMBDA' },
        Wideawake: {
            computeService: 'FARGATE',
            options: {
                scalingLimits: null,
                sizing: stage === 'prod'
                    ? { cpu: 512, memoryLimitMiB: 1024 }
                    : stage === 'test'
                        ? { cpu: 256, memoryLimitMiB: 512 } // test ok
                        : { cpu: 256, memoryLimitMiB: 512 },
            },
        },
        EntityState: defaultEnvironmentComputeDeploymentConfig === 'FARGATE'
            ? {
                computeService: 'FARGATE',
                options: {
                    scalingLimits: {
                        minCapacity: stage === 'prod' ? 2 : 1, // Baseline for steady traffic
                        maxCapacity: stage === 'prod' ? 4 : stage === 'test' ? 1 : 1,
                    },
                    capacityProviderStrategies: stage === 'prod' ? [
                        {
                            capacityProvider: 'FARGATE',
                            base: 1,
                            weight: 1,
                        },
                        {
                            capacityProvider: 'FARGATE_SPOT',
                            weight: 1,
                        },
                    ] : [
                        { capacityProvider: 'FARGATE_SPOT', weight: 1 }
                    ],
                    sizing: stage === 'prod' ? { cpu: 256, memoryLimitMiB: 512 } : stage === 'test' ? { cpu: 256, memoryLimitMiB: 512 } : { cpu: 256, memoryLimitMiB: 512 },
                },
            }
            : { computeService: 'LAMBDA' },
    },
};
